// extracted by mini-css-extract-plugin
export default {"indicator":"J_ScTsJq3sUoIKTedV9V","alert":"_4o72P_CMOZpPcwBPasWX"};